import React from 'react'

import {
    ResponsiveContainer,
    LineChart,
    Line,
    XAxis,
    YAxis,
    CartesianGrid,
    Tooltip,
    ReferenceArea,
} from 'recharts'

const stringAfter = (stringToFind, value) => {
    const index = value.indexOf(stringToFind)
    if (index === -1) return value

    return value.substr(index + stringToFind.length)
}

const CustomTooltip = ({ active, payload, label, events }) =>
    active &&
    payload && (
        <div className="custom-tooltip">
            <h4>{label}</h4>
            {payload.map(tagValue => (
                <div key={tagValue.name}>
                    <span
                        className="m-r-sm"
                        style={{
                            display: 'inline-block',
                        }}
                    >
                        <strong>{tagValue.value}</strong>
                    </span>
                    <span
                        style={{
                            color: tagValue.stroke,
                        }}
                    >
                        <strong>{events[tagValue.name]}</strong>
                    </span>
                </div>
            ))}
        </div>
    )

const ScansChart = ({ events, scans, palette, zebraStripes }) => {
    const eventDescriptionIndexedByEventId = events.reduce(
        (acc, event) => ({
            ...acc,
            [event.eventId]: event.eventName,
        }),
        {},
    )

    return (
        <ResponsiveContainer width="100%" height={250}>
            <LineChart
                data={scans}
                margin={{
                    top: 10,
                    right: 30,
                    left: 0,
                    bottom: 0,
                }}
            >
                <CartesianGrid strokeDasharray="3 3" />
                <XAxis
                    padding={{ left: 20, right: 20 }}
                    dataKey="DayAndTimeDescription"
                    tickFormatter={timeStr => stringAfter(' @ ', timeStr)}
                />
                <YAxis />
                <Tooltip
                    content={
                        <CustomTooltip
                            events={eventDescriptionIndexedByEventId}
                        />
                    }
                />

                {zebraStripes.map(zebraStripe => (
                    <ReferenceArea
                        key={zebraStripe.startDescription}
                        x1={zebraStripe.startDescription}
                        x2={zebraStripe.endDescription}
                        opacity={0.3}
                        alwaysShow
                    />
                ))}

                {events.map((event, index) => (
                    <Line
                        dot={false}
                        key={event.eventId}
                        type="monotone"
                        dataKey={event.eventId}
                        stroke={palette[index]}
                        strokeWidth={2}
                    />
                ))}
            </LineChart>
        </ResponsiveContainer>
    )
}
export default ScansChart
